import React from 'react';
import { getApprovalSteps } from '../../utils/directOrderStatus';

const STATE_TEXT = {
  approved: 'Approved',
  rejected: 'Rejected',
  current: 'Awaiting review',
  waiting: 'Not started',
};

const Check = () => (
  <svg width="8" height="8" viewBox="0 0 8 8" aria-hidden="true">
    <path d="M1.2 4.2 3.2 6.1 6.8 1.9" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const Cross = () => (
  <svg width="8" height="8" viewBox="0 0 8 8" aria-hidden="true">
    <path d="M1.5 1.5 6.5 6.5M6.5 1.5 1.5 6.5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const Node = ({ state }) => (
  <span className={`do-track__node do-track__node--${state}`}>
    {state === 'approved' && <Check />}
    {state === 'rejected' && <Cross />}
  </span>
);

const summary = (steps) =>
  steps.map((s) => `${s.name}: ${STATE_TEXT[s.state].toLowerCase()}`).join(', ');

/**
 * The three-person approval chain for a direct order.
 *  compact  - dots and connectors only (tables, lists)
 *  full     - horizontal, with names and state underneath (detail view)
 *  vertical - stacked, with each level's position (or label) underneath (create page)
 */
const ApprovalTrack = ({ order, variant = 'compact', roles }) => {
  const steps = getApprovalSteps(order || {});
  const label = `Approval chain. ${summary(steps)}`;

  if (variant === 'compact') {
    return (
      <span className="do-track" role="img" aria-label={label}>
        {steps.map((step, i) => (
          <React.Fragment key={step.key}>
            <span title={`${step.name}: ${STATE_TEXT[step.state].toLowerCase()}`} style={{ display: 'inline-flex' }}>
              <Node state={step.state} />
            </span>
            {i < steps.length - 1 && (
              <span className={`do-track__link${step.state === 'approved' ? ' do-track__link--done' : ''}`} />
            )}
          </React.Fragment>
        ))}
      </span>
    );
  }

  if (variant === 'vertical') {
    return (
      <div className="do-track do-track--vertical" role="img" aria-label={label}>
        {steps.map((step, i) => (
          <div className="do-track__step" key={step.key}>
            <div className="do-track__rail">
              <Node state={step.state} />
              {i < steps.length - 1 && (
                <span className={`do-track__link${step.state === 'approved' ? ' do-track__link--done' : ''}`} />
              )}
            </div>
            <div className="do-track__text">
              <span className="do-track__name">{step.name}</span>
              <span className="do-track__state">{roles ? roles[i] : step.title || step.label}</span>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="do-track do-track--full" role="img" aria-label={label}>
      {steps.map((step, i) => (
        <div className="do-track__step" key={step.key}>
          <div className="do-track__rail">
            <Node state={step.state} />
            {i < steps.length - 1 && (
              <span className={`do-track__link${step.state === 'approved' ? ' do-track__link--done' : ''}`} />
            )}
          </div>
          <span className="do-track__name" title={step.title ? `${step.name}, ${step.title}` : undefined}>{step.name}</span>
          <span className={`do-track__state do-track__state--${step.state}`}>{STATE_TEXT[step.state]}</span>
        </div>
      ))}
    </div>
  );
};

export default ApprovalTrack;
